import { Heading } from 'src/pages-all/user/user-profile/components/common';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import { fontSize } from 'styles/theme';
import { Card } from 'antd';

export const SubHeading = styled.div<{ minTablet: boolean }>`
  display: block;
  color: ${colors.blueGray};
  margin: 10px 0 20px 0;
  margin-left: ${({ minTablet }) => (minTablet ? '0' : '16px')};
  margin-right: ${({ minTablet }) => (minTablet ? '0' : '16px')};
  font-weight: 600;
`;

export const StyledHeading = styled(Heading)<{ minTablet: boolean }>`
  margin-top: 40px;
  font-size: ${({ minTablet }) => (minTablet ? fontSize['2xl'] : fontSize['xl'])} !important;
  margin-left: ${({ minTablet }) => (minTablet ? '0' : '16px')};
  margin-right: ${({ minTablet }) => (minTablet ? '0' : '16px')};
`;

export const StyledInfoCard = styled(Card)`
  margin: 0 0 20px 0;
`;

export const InfoDescription = styled.div`
  font-weight: 500;
  text-align: center;
`;
